
export const INITIATE_PASSWORD_RESET_STARTED = "INITIATE_PASSWORD_RESET_STARTED";
export const INITIATE_PASSWORD_RESET_DEFAULT = "INITIATE_PASSWORD_RESET_DEFAULT";
export const INITIATE_PASSWORD_RESET_SUCCEEDED = "INITIATE_PASSWORD_RESET_SUCCEEDED";
export const INITIATE_PASSWORD_RESET_FAILED = "INITIATE_PASSWORD_RESET_FAILED";
export const VALIDATE_PASSWORD_RESET = "VALIDATE_PASSWORD_RESET";
export const VALIDATE_PASSWORD_RESET_DEFAULT = "VALIDATE_PASSWORD_RESET_DEFAULT";
export const VALIDATE_PASSWORD_RESET_SUCCEEDED = "VALIDATE_PASSWORD_RESET_SUCCEEDED";
export const VALIDATE_PASSWORD_RESET_FAILED = "VALIDATE_PASSWORD_RESET_FAILED";
export const VALIDATE_PASSWORD_RESET_STARTED = "VALIDATE_PASSWORD_RESET_STARTED";
export const VALIDATE_PASSWORD_WITH_OTP_DEFAULT = "VALIDATE_PASSWORD_WITH_OTP_DEFAULT";
export const VALIDATE_PASSWORD_WITH_OTP_SUCCEEDED = "VALIDATE_PASSWORD_WITH_OTP_SUCCEEDED";
export const VALIDATE_PASSWORD_WITH_OTP_FAILED = "VALIDATE_PASSWORD_WITH_OTP_FAILED";
export const VALIDATE_PASSWORD_WITH_OTP_STARTED = "VALIDATE_PASSWORD_WITH_OTP_STARTED";
export const RESET_PASSWORD_WITH_OTP_DEFAULT = "RESET_PASSWORD_WITH_OTP_DEFAULT";
export const RESET_PASSWORD_WITH_OTP_SUCCEEDED = "RESET_PASSWORD_WITH_OTP_SUCCEEDED";
export const RESET_PASSWORD_WITH_OTP_FAILED = "RESET_PASSWORD_WITH_OTP_FAILED";
export const RESET_PASSWORD_WITH_OTP_STARTED = "RESET_PASSWORD_WITH_OTP_STARTED";
export const RESET_PASSWORD_WITH_TRANSACTION_PIN_STARTED = "RESET_PASSWORD_WITH_TRANSACTION_PIN_STARTED";
export const RESET_PASSWORD_WITH_TRANSACTION_PIN_SUCCEEDED = "RESET_PASSWORD_WITH_TRANSACTION_PIN_SUCCEEDED";
export const RESET_PASSWORD_WITH_TRANSACTION_PIN_FAILED = "RESET_PASSWORD_WITH_TRANSACTION_PIN_FAILED";